/** Small presentational primitives shared by the Blueprint sections. */
export const SectionHeader = ({ icon: Icon, kicker, title }) => (
  <div className="mb-8">
    <p className="flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-[hsl(var(--lxra-gold))]">
      <Icon className="h-4 w-4" />
      {kicker}
    </p>
    <h2 className="font-display text-3xl sm:text-4xl tracking-[0.03em] text-[hsl(var(--lxra-fg))] mt-2">{title}</h2>
    <div className="mt-4 h-[2px] w-12 bg-[hsl(var(--lxra-gold))]" />
  </div>
);

export const Card = ({ children, className = '' }) => (
  <div className={`rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] p-6 ${className}`}>{children}</div>
);

export const CardKicker = ({ icon: Icon, children }) => (
  <p className="flex items-center gap-2 text-xs tracking-[0.18em] uppercase text-[hsl(var(--lxra-gold))]">
    <Icon className="h-4 w-4" /> {children}
  </p>
);

export const priorityBadge = (p) =>
  p === 'must'
    ? 'bg-[hsl(var(--lxra-gold))]/15 text-[hsl(var(--lxra-gold-hover))] border-[hsl(var(--lxra-gold))]/30'
    : 'bg-transparent text-[hsl(var(--lxra-muted))] border-[hsl(var(--lxra-border))]';

export const goldLinkClass = 'inline-flex items-center justify-center h-11 px-6 rounded-xl bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))] transition-colors text-xs uppercase tracking-[0.1em] font-semibold';
export const outlineLinkClass = 'inline-flex items-center justify-center h-11 px-6 rounded-xl border border-[hsl(var(--lxra-gold))]/50 text-[hsl(var(--lxra-fg))] hover:border-[hsl(var(--lxra-gold))] hover:text-[hsl(var(--lxra-gold))] transition-colors text-xs uppercase tracking-[0.1em] font-medium';
